import { createAction } from '@lingoda/core';

export const clearFilter = createAction('booking/REMOVE_FILTER');
